/**
 * El CSV de las filas que NO entraron, para corregir el archivo original sin adivinar.
 *
 * Vivía dentro del asistente rápido, que estaba plegado en un `<details>` cerrado — o sea que
 * la única forma de llevarse los rechazos era abrir un acordeón que nadie sabía que existía.
 * Ahora se usa desde los DOS sitios donde aparecen filas con error: el ensayo de una hoja y
 * el resultado de la carga.
 */

const esc = (v) => `"${String(v ?? '').replace(/"/g, '""')}"`;

/** Las filas de un diagnóstico que el asesor tiene que corregir. */
export function filasConProblema(filas = []) {
  return filas.filter((f) => f.estado === 'error' || f.estado === 'aviso');
}

/**
 * Descarga el CSV de rechazos. El BOM va a propósito: sin él Excel abre los acentos rotos y
 * el asesor cree que el problema son los datos.
 */
export function descargarRechazos(filas, nombre) {
  const csv = [
    'fila,clave,estado,motivo',
    ...filas.map((f) =>
      [f.fila, esc(f.clave || ''), esc(f.estado || ''), esc((f.motivos || []).join(' | '))].join(',')
    ),
  ].join('\n');
  const url = URL.createObjectURL(new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = `rechazos-${nombre || 'migracion'}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}

export default descargarRechazos;
